<template>
  <article class="d-block col-lg-5 col-xxs-12 h-100 vh-100-auto bg-white text-dark p-0">
    <section class="d-flex flex-column w-100 p-sm-5 p-xxs-4 bg-white">
      <h1 class="text-danger mb-5 mt-5 px-md-5 px-sm-3 px-xs-1">
        {{ configurations.title }}
      </h1>
      <p class="terms-description px-md-5 px-sm-3 px-xs-1 text-justify" v-html="configurations.text" />
    </section>
  </article>
</template>

<script>
import Vue from 'vue'
export default Vue.extend({
  name: 'SimpleArticle',
  props: {
    configurations: {
      type: Object,
      default: () => {}
    }
  }
})
</script>
